import { type FC } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ProductsItem } from "@/partner/entities/products";

interface ProductThumbnailProps {
  product: Pick<ProductsItem, "preview">;
}

/**
 * Превью продукта в списке (референс: components/ProductThumbnail) —
 * без hover-видео: у продукта нет собственного промо-видео (это поле
 * есть только у референсной модели, в нашей backend-схеме Task 3 его нет).
 */
export const ProductThumbnail: FC<ProductThumbnailProps> = ({ product }) => {
  const { t } = useTranslation();
  const image = product.preview?.url;

  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: 160 / 1.5, sm: 160 },
        height: { xs: 90 / 1.5, sm: 90 },
        flexShrink: 0,
        borderRadius: 1,
        overflow: "hidden",
        // référence: ProductThumbnail.js Root — rgba(0,0,0,0.5) фон + белый
        // текст поверх (плашка-заглушка без превью), cursor pointer.
        bgcolor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {image ? (
        <img
          src={String(image)}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <Typography variant="caption" sx={{ p: 1 }}>
          {t("products.thumbnail.noPreview")}
        </Typography>
      )}
    </Box>
  );
};
